// Utility to detect if device is mobile
export const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Check user agent for mobile indicators
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  return mobileRegex.test(userAgent.toLowerCase());
};

// Handle link clicks with device awareness
export const handleLinkClick = (href, isMobile = false) => {
  const mobile = isMobile || isMobileDevice();
  
  if (mobile) {
    // Mobile: open in same window/tab
    window.location.href = href;
  } else {
    // Desktop: open in new tab
    window.open(href, '_blank', 'noopener,noreferrer');
  }
};